import React from 'react';
import PlacementTestItemsListFilter from './PlacementTestItemsListFilter';
import { observer } from 'mobx-react';
import PlacementTestItemsListService from '../services/PlacementTestItemsListService';

class PlacementTestItemsListFilterContainer extends React.Component {
  render() {
    return (
      <PlacementTestItemsListFilter
        onChange={PlacementTestItemsListService.form.setValue}
        values={PlacementTestItemsListService.form.getValues()}
        onSearch={PlacementTestItemsListService.load}
      />
    );
  }
}

export default observer(PlacementTestItemsListFilterContainer);
